import apiBaseState from "~/constants/apiBaseState";

export const state = () => ({
    aiTagsState: apiBaseState()
});

export const mutations = {
    SET_AI_TAGS(state, payload){
        state.aiTagsState = payload;
    }
};

export const actions = {
    GET_AI_TAGS(context) {
        if(context.state.aiTagsState.data === null) {
            const url = `/ai/tags`;
            return this.$whyApi.get({
                url,
                mutation: "chatGpt/SET_AI_TAGS",
                errorMessage: "Error getting ai tags",
                notify: this.$notify
            });
        }
    },
};
